import React, { forwardRef } from "react";
import { StyledButton } from "./button.styles";
import { ButtonProps } from "./button.types";

const typeMap = {
    tertiary: "text",
    secondary: "default",
};

const sizeMap = {
    regular: "regular",
};

export const Button = forwardRef<HTMLElement, ButtonProps>(
    (
        { children, type = "secondary", size = "regular", error, ...rest },
        ref
    ) => {
        return (
            <StyledButton
                ref={ref}
                type={typeMap[type] || type}
                size={sizeMap[size] || size}
                danger={error}
                {...rest}
            >
                {children}
            </StyledButton>
        );
    }
);

Button.displayName = "Button";
